import React, { FC, PropsWithChildren } from 'react'

import { styled } from '@linaria/react'

export const PhotoWithoutSlide: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Parent>
      <Body>{children}</Body>
    </Parent>
  )
}

const Parent = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  overflow: hidden;
`

const Body = styled.div`
  display: flex;
  min-width: 100%;
`
